import get from 'lodash/get';

import type { IGlobalState } from '@src/reducers';

export const selectFullDealCalculator = (state: IGlobalState) => state.fullDeal.calculator;
export const selectFullDealCalculatorFeatures = (state: IGlobalState) => state.fullDeal.features;
export const selectFullDealCalculatorBranding = (state: IGlobalState) => {
  const data = state.fullDeal.branding;

  return {
    desktop: {
      backgroundColor: get(data, 'desktop.creditCalculator.backgroundColor'),
      backgroundImage: get(data, 'data.desktop.creditCalculator.backgroundImage.webp'),
    },
    mobile: {
      backgroundColor: get(data, 'mobile.creditCalculator.backgroundColor'),
      backgroundImage: get(data, 'mobile.creditCalculator.backgroundImage.webp'),
    },
  };
};
